import * as mt from './mutation-types';
import { Auth } from './types';

export default {
  [mt.AUTH_REQUEST](state: Auth) {
    state.status = 'loading';
  },
  [mt.AUTH_SUCCESS](state: Auth, response: { accessToken: string }) {
    state.status = 'success';
    state.accessToken = response.accessToken;
  },
  [mt.AUTH_ERROR](state: Auth, error: { type: any; message: any }) {
    state.status = 'error';
    state.errorType = error.type;
    state.errorMessage = error.message;
  },
  [mt.AUTH_LOGGING_OUT](state: Auth) {
    state.status = 'logging-out';
  },
  [mt.AUTH_LOGOUT](state: Auth) {
    state.accessToken = '';
    state.status = '';
  },

  [mt.INTEGRATION_AUTH_REQUEST](state: Auth) {
    state.status = 'loading';
  },
  
};
